/**
 * API base URL. Empty string means requests use relative paths and go through
 * the same origin (Cloudflare Pages -> Worker proxy). This avoids cross-origin
 * and DNS issues on restricted networks (e.g. some tablets/mobile networks that
 * cannot reach the raw *.workers.dev domain directly).
 *
 * In local development Vite proxies /api and /media to the Worker.
 */
export const API_BASE = "";

/**
 * API fetch wrapper that automatically injects the admin token
 * from localStorage as a Bearer Authorization header.
 * Replaces EdgeSpark's client.api.fetch which doesn't work with
 * our custom RBAC session token system.
 */
export async function apiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const token = localStorage.getItem("admin_token");
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });
}
